import React from 'react';
import './login-header.scss';

import { Link } from 'gatsby';
import { SmallLanguageSwitcher, TranslatedBlock } from './language';
import RocheLogo from '../images/Roche_logo.png';
import EnspryngLogo from 'src/images/ENSPRYNG_logo.svg';

export default function LoginHeader() {
  return (
    <header className="login-topbar">
      <div className="container">
        <Link to="/" className={'custom-logo-link'}>
          <TranslatedBlock language="english">
            <img src={EnspryngLogo} alt="ENSPRYNG logo" className={'logo-img'} />
          </TranslatedBlock>
          <TranslatedBlock language="french">
            <img src={EnspryngLogo} alt="ENSPRYNG logo" className={'logo-img'} />
          </TranslatedBlock>
        </Link>
        <div className="roche-logo-container">
          <SmallLanguageSwitcher />
          <img src={RocheLogo} alt="Roche logo" className={'roche-logo-img'} />
        </div>
      </div>
    </header>
  );
}
